import React, {useState, useEffect} from 'react';
import {injectIntl} from 'react-intl';
import Button from '@react/react-spectrum/Button';
// import Star from '@react/react-spectrum/Icon/Star';
import Close from '@react/react-spectrum/Icon/Close';
import open from '../../../utils/open';
import BannerAnalytics from './analytics/BannerAnalytics';
import './CCBanner.scss';
interface Props {
	intl: any;
}

const CCBanner = ({intl}: Props) => {
	const [dismiss, setDismiss] = useState(false);
	// @ts-ignore
	const forceUpdate = React.useReducer(bool => !bool)[1];

	useState(() => {
		window.addEventListener('orientationchange', forceUpdate);

		return () => {
			window.removeEventListener('orientationchange', forceUpdate);
		};
		// @ts-ignore
	}, []);

	if (
		dismiss
		|| !window.cchome.util.isMobileOrTabletBrowser()
		|| (localStorage && localStorage.getItem('dismissedCCMobileBanner'))
	) {
		const leftNav = document.getElementsByClassName('leftnav-container')[0];
		const appContainer = document.getElementsByClassName('app-container')[0];
		// For the new leftnav for apphomes
		const leftNavHostContainer = document.getElementsByClassName('leftnav-host-container')[0];

		if (appContainer && appContainer.classList.contains('with-top-banner')) {
			appContainer.classList.remove('with-top-banner');
		}
		if (leftNav && leftNav.classList.contains('with-top-banner')) {
			leftNav.classList.remove('with-top-banner');
		}
		if (leftNavHostContainer && leftNavHostContainer.classList.contains('with-top-banner')) {
			leftNavHostContainer.classList.remove('with-top-banner');
		}
		return null;
	}

	const handleDismiss = () => {
		const analytics = new BannerAnalytics();
		analytics.postCCMobileBannerDismissClick();
		dismissBanner();
	};

	const dismissBanner = () => {
		localStorage && localStorage.setItem('dismissedCCMobileBanner', 'true');
		setDismiss(true);
	};

	const downloadCCMobile = () => {
		dismissBanner();
		open('https://creativecloud.app.link/cchome', '_self');
	};

	return (
		<div className='ccmob-top-banner-container'>
			<div className='ccmob-top-banner-inner'>
				<div className='ccmob-dismiss-button'>
					<Button icon={<Close size='S' />} variant='tool' onClick={handleDismiss} tabIndex={0} />
					{/* <Close size='S' /> */}
				</div>
				<div className='ccmob-img-container'>
					<img src='/assets/common/creativecloudIcon.png' />
				</div>
				<div className='ccmob-detail-container'>
					<div className='ccmob-title'>
						<h1>{intl.formatMessage({id: 'app.navbar.title'})}</h1>
					</div>
					<div className='ccmob-description'>
						<span>{intl.formatMessage({id: 'app.banner.ccmobileBanner.description'})}</span>
					</div>
					{/* <div className='ccmob-ratings'>
          <Star size='XS'/><Star size='XS'/><Star size='XS'/><Star size='XS'/><Star size='XS'/>
          <span>(33K+ {intl.formatMessage({id: 'banner.ccmobileBanner.ratings'})})</span>
          </div> */}
				</div>
				<div className='ccmob-download-button'>
					<Button
						label={intl.formatMessage({id: 'app.get'})}
						variant='cta'
						onClick={downloadCCMobile}
						tabIndex={0}
					/>
				</div>
			</div>
		</div>
	);
};

export default injectIntl(CCBanner);
